export default __webpack_public_path__ + "static/media/banks.bcee8d62.webp";